import React from 'react';
import { PrizeTier } from './types';

interface RiskModalProps {
  currentPrize: PrizeTier;
  nextPrize?: PrizeTier;
  onRiskIt: () => void;
  onCashOut: () => void;
}

const RiskModal: React.FC<RiskModalProps> = ({
  currentPrize,
  nextPrize,
  onRiskIt,
  onCashOut,
}) => {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fade-in">
      <div className="bg-gradient-to-br from-kbc-dark to-kbc-dark-accent max-w-lg w-full rounded-2xl border-2 border-kbc-gold shadow-2xl animate-slide-up">
        {/* Header */}
        <div className="bg-kbc-gold text-maersk-navy p-6 rounded-t-2xl">
          <h2 className="text-2xl md:text-3xl font-bold text-center">
            🎯 Risk It or Cash Out?
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 md:p-8">
          {/* Congratulations Message */}
          <div className="mb-6 text-center">
            <p className="text-kbc-gold text-lg font-bold mb-2">
              🎉 Tier {currentPrize.level} Completed!
            </p>
            <p className="text-white/80 text-sm">
              You've secured this prize. Risk it for the next tier?
            </p>
          </div>

          {/* Current Prize */}
          <div className="mb-6">
            <p className="text-white/80 text-sm mb-2">Prize Secured:</p>
            <div className="bg-kbc-gold/20 border-2 border-kbc-gold rounded-lg p-4">
              <div className="text-center">
                <p className="text-kbc-gold text-sm font-semibold mb-1">
                  Tier {currentPrize.level}
                </p>
                <p className="text-white text-xl font-bold">
                  {currentPrize.label}
                </p>
              </div>
            </div>
          </div>

          {/* Next Prize */}
          {nextPrize && (
            <div className="mb-8">
              <p className="text-white/80 text-sm mb-2">Continue to compete for:</p>
              <div className="bg-white/10 border-2 border-white/30 rounded-lg p-4">
                <div className="text-center">
                  <p className="text-kbc-amber text-sm font-semibold mb-1">
                    Tier {nextPrize.level} (4 more questions)
                  </p>
                  <p className="text-white text-xl font-bold">
                    {nextPrize.label}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Warning */}
          <div className="bg-kbc-error/20 border border-kbc-error/40 rounded-lg p-4 mb-6">
            <p className="text-white text-sm text-center">
              ⚠️ <span className="font-bold">Warning:</span> One wrong answer and you lose all prizes!
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            <button
              onClick={onRiskIt}
              className="w-full bg-kbc-amber hover:bg-kbc-gold text-maersk-navy font-bold text-lg py-4 rounded-lg shadow-lg transform transition hover:scale-105 active:scale-95"
            >
              🚀 Risk It - Continue Playing
            </button>
            
            <button
              onClick={onCashOut}
              className="w-full bg-kbc-success hover:bg-green-600 text-white font-bold text-lg py-4 rounded-lg shadow-lg transform transition hover:scale-105 active:scale-95"
            >
              💰 Cash Out - Take {currentPrize.label}
            </button>
          </div>

          {/* Hint */}
          <p className="text-white/60 text-center text-sm mt-4">
            Choose wisely! One wrong answer and it's game over.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RiskModal;
